// React imports
import React, { useState } from 'react';
import { useForm } from 'react-hook-form';

// Material-UI imports

// Other imports
// @ts-ignore
import { yupResolver } from '@hookform/resolvers/yup';
// @ts-ignore
import * as yup from 'yup';

// Absolute imports
import { getCookie } from 'utils/Cookies';

// Relative imports

type FormData = {
  email: string;
};

const schema = yup.object().shape({
  email: yup
    .string()
    .email('Please enter a valid email address.')
    .required('Please enter a valid email address.'),
});

export function usePasswordResetPage() {
  // Refs

  // States
  const [email, setEmail] = useState<String>('');

  // Hooks
  const form = useForm<FormData>({
    defaultValues: {
      email: '',
    },
    mode: 'onBlur',
    //@ts-ignore
    resolver: yupResolver(schema),
  });

  // Effects

  // Body code

  // Functions
  function getOnSubmit() {
    return form.handleSubmit(async (data: FormData) => {
      await send(data.email);
    });
  }

  function send(email: String) {
    const requestOptions = {
      method: 'POST',
      headers: [
        ['Content-Type', 'application/json'],
        ['X-CSRFToken', getCookie('csrftoken') || ''],
      ],
      body: JSON.stringify({
        email,
      }),
    };
    return fetch(
      `${window.location.protocol}//${window.location.host}/api/password-reset/`,
      requestOptions,
    )
      .then((res) => {
        if (res.status !== 200) {
          console.log('Password reset was not successful');
          return null;
        }
        return res.json();
      })
      .then((data) => {
        if (data?.oidc_reset_password_url) {
          window.location.href = data.oidc_reset_password_url;
        } else {
          form.reset();
          setEmail(email);
        }
      });
  }

  return {
    email,
    getOnSubmit,
    form,
  };
}
